{
  "eyebrow": "Step {{current}} of {{total}} · {{section}}",
  "part": "{{position}} of {{total}} in this step",
  "back": "Back",
  "next": "Next",
  "done": "Done",
  "close": "Close the guide",
  "sections": {
    "addEvents": "Add events",
    "customize": "Customize",
    "collaborate": "Collaborate",
    "sendToCalendar": "Send to calendar"
  },
  "steps": {
    "magic": {
      "title": "Start with Magic",
      "body": "Turn text, images, or PDFs into events you review before they land. No plans yet? <action>Try example</action> fills the box with some, so you have something to explore."
    },
    "import": {
      "title": "Import what you already use",
      "body": "Open Customize → Sources to connect another calendar or paste a feed URL."
    },
    "switchViews": {
      "title": "See your plan your way",
      "body": "Switch this planner between month, week, list, and printable layouts."
    },
    "viewSettings": {
      "title": "Tune each view",
      "body": "Open Customize → Views to add a view and choose what each one shows."
    },
    "style": {
      "title": "Make it look like yours",
      "body": "Open Customize → Style to change the vibe, colors, and card style."
    },
    "invite": {
      "title": "Invite the people involved",
      "body": "Share the planner with collaborators so they can add and edit events too."
    },
    "send": {
      "title": "Send events anywhere",
      "body": "Export to Google, Apple, or Outlook, once or kept in sync."
    }
  },
  "success": {
    "toast_title": "Planner ready",
    "toast_body": "Add another event, or keep exploring at your own pace."
  },
  "help": {
    "heading": "Planner guide",
    "restart": "Restart the planner guide",
    "restarted": "The guide will show on your next new planner."
  }
}
